<template>
  <v-expansion-panels accordion>
    <v-expansion-panel>
      <v-expansion-panel-header>{{
        $t("restrictions")
      }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-expansion-panels accordion :value="[0, 1, 2]">
          <v-expansion-panel>
            <v-expansion-panel-header>{{
              $t("restrictStatus")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="py-0">
                <v-col class="py-0">
                  <v-checkbox
                    disabled
                    class="pt-0 mt-1"
                    v-model="restrictions.statusRestrictions.restrict"
                    :label="$t('restrict')"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="py-0 mt-2">
                <v-col class="py-0">
                  <v-data-table
                    v-if="restrictions.statusRestrictions.restrict"
                    :headers="headers"
                    :header-props="{ sortByText: $t('sortBy') }"
                    :items="restrictions.statusRestrictions.times"
                    hide-default-footer
                    dense
                  >
                    <template v-slot:item.day="{ item }">
                      {{ $t(item.day) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>{{
              $t("restrictTakeaway")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="py-0">
                <v-col class="py-0">
                  <v-checkbox
                    disabled
                    class="pt-0 mt-1"
                    v-model="restrictions.takeawayRestrictions.restrict"
                    :label="$t('restrict')"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="py-0 mt-2">
                <v-col class="py-0">
                  <v-data-table
                    v-if="restrictions.takeawayRestrictions.restrict"
                    :headers="headers"
                    :header-props="{ sortByText: $t('sortBy') }"
                    :items="restrictions.takeawayRestrictions.times"
                    hide-default-footer
                    dense
                  >
                    <template v-slot:item.day="{ item }">
                      {{ $t(item.day) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>{{
              $t("restrictDelivery")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="py-0">
                <v-col class="py-0">
                  <v-checkbox
                    disabled
                    class="pt-0 mt-1"
                    v-model="restrictions.deliveryRestrictions.restrict"
                    :label="$t('restrict')"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="py-0 mt-2">
                <v-col class="py-0">
                  <v-data-table
                    v-if="restrictions.deliveryRestrictions.restrict"
                    :headers="headers"
                    :header-props="{ sortByText: $t('sortBy') }"
                    :items="restrictions.deliveryRestrictions.times"
                    hide-default-footer
                    dense
                  >
                    <template v-slot:item.day="{ item }">
                      {{ $t(item.day) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>{{
              $t("restrictInplace")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="py-0">
                <v-col class="py-0">
                  <v-checkbox
                    disabled
                    class="pt-0 mt-1"
                    v-model="restrictions.inplaceRestrictions.restrict"
                    :label="$t('restrict')"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="py-0 mt-2">
                <v-col class="py-0">
                  <v-data-table
                    v-if="restrictions.inplaceRestrictions.restrict"
                    :headers="headers"
                    :header-props="{ sortByText: $t('sortBy') }"
                    :items="restrictions.inplaceRestrictions.times"
                    hide-default-footer
                    dense
                  >
                    <template v-slot:item.day="{ item }">
                      {{ $t(item.day) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: ["restrictions"],
  data() {
    return {
      headers: [
        { text: this.$t("day"), value: "day", sortable: false },
        { text: this.$t("from"), value: "from", sortable: false },
        { text: this.$t("to"), value: "to", sortable: false },
      ],
      rules: {
        required: (value) => !!value || this.$t("requiredField"),
        digitalTime: (value) =>
          /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value) || "HH:MM",
      },
    };
  },
  methods: {},
};
</script>